var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbonBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135 51",
    style: {
      enableBackground: "new 0 0 135 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3703A4;}\n\t.st1{fill:#5A34E1;}\n\t.st2{fill:#FF463A;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{mask:url(#mask0_3837_18296_00000044178166655271431090000014199991115423658429_);}\n\t.st4{fill:#8133CF;fill-opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.1,26.7l10.1-17c0.2-0.3,0.3-0.7,0.2-1c0-0.4-0.2-0.7-0.4-1c-0.2-0.3-0.6-0.5-1-0.7 c-0.4-0.2-0.8-0.3-1.3-0.3h-21.3c-0.6,0-1.1,0.1-1.6,0.4c-0.5,0.3-0.8,0.6-1,1L97.3,33.4c-0.1,0.2-0.1,0.4-0.1,0.7v10.5 c0,0.6,0.3,1.1,0.8,1.5c0.5,0.4,1.2,0.6,1.9,0.6h31.9c0.4,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,1-0.7c0.2-0.3,0.4-0.6,0.4-1 c0-0.4-0.1-0.7-0.2-1L124.1,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.3,8.2c-0.2-0.4-0.5-0.8-1-1c-0.5-0.3-1-0.4-1.6-0.4H3.5C3.1,6.7,2.6,6.8,2.3,7c-0.4,0.2-0.7,0.4-1,0.7 C1.1,8,0.9,8.4,0.9,8.7c0,0.4,0.1,0.7,0.2,1l10.1,17l-10.1,17c-0.2,0.3-0.3,0.7-0.2,1s0.2,0.7,0.4,1c0.2,0.3,0.6,0.5,1,0.7 c0.4,0.2,0.8,0.3,1.3,0.3h31.9c0.7,0,1.4-0.2,1.9-0.6c0.5-0.4,0.8-0.9,0.8-1.5V34.1c0-0.2,0-0.5-0.1-0.7L27.3,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.4,0.6H24.6c-1.7,0-3,1.1-3,2.4v37.5c0,1.3,1.4,2.4,3,2.4h85.7c1.7,0,3-1.1,3-2.4V3.1 C113.4,1.7,112,0.6,110.4,0.6z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 29.7,
    y: -16.5,
    width: 77.4,
    height: 77.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 29.7,
    y: -16.5,
    width: 77.4,
    height: 77.4,
    id: "mask0_3837_18296_00000044178166655271431090000014199991115423658429_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.4,0.6H24.6c-1.7,0-3,1.1-3,2.4v37.5c0,1.3,1.4,2.4,3,2.4h85.7c1.7,0,3-1.1,3-2.4V3.1 C113.4,1.7,112,0.6,110.4,0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.2,22.3c0,10.9-8.9,19.8-19.8,19.8c-10.9,0-19.8-8.9-19.8-19.8S57.5,2.4,68.4,2.4 C79.3,2.4,88.2,11.3,88.2,22.3z M52.2,22.3c0,9,7.3,16.2,16.2,16.2s16.2-7.3,16.2-16.2S77.4,6,68.4,6S52.2,13.3,52.2,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.1,22.3c0,21.4-17.3,38.7-38.7,38.7C47,61,29.7,43.6,29.7,22.3c0-21.4,17.3-38.7,38.7-38.7 C89.8-16.5,107.1,0.9,107.1,22.3z M36.7,22.3C36.7,39.8,50.9,54,68.4,54c17.5,0,31.7-14.2,31.7-31.7S85.9-9.5,68.4-9.5 C50.9-9.5,36.7,4.7,36.7,22.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonBlue);
export default __webpack_public_path__ + "static/media/ribbon_blue.253e1cba2508d7479c7b75ba7682ab56.svg";
export { ForwardRef as ReactComponent };